/* Move existing sections, preserving their live forms and event handlers.
   Original positions are restored whenever the viewport returns to mobile. */
(() => {
  function init() {
    // Keep Shopify section wrappers in their original positions in the editor.
    if (window.Shopify?.designMode) return;
    const main = document.getElementById('MainContent');
    const banner = main?.querySelector('.banner-sectionpr');
    const info = banner?.querySelector('.banner-sectionpr__col--info');
    if (!info || banner.dataset.mmLayout) return;
    banner.dataset.mmLayout = 'ready';
    const root = banner.closest('.shopify-section');
    if (!root || root.parentElement !== main) return;
    const moved = [];
    let next = root.nextElementSibling;
    while (next) {
      if (next.classList.contains('shopify-section') && !next.querySelector('product-recommendations')) {
        const anchor = document.createComment('mm-original-section-position');
        next.before(anchor);
        moved.push({ node: next, anchor });
      }
      next = next.nextElementSibling;
    }
    const desktop = window.matchMedia('(min-width: 990px)');
    function update() {
      moved.forEach(({ node, anchor }) => {
        if (desktop.matches) info.append(node);
        else anchor.after(node);
      });
    }
    update();
    desktop.addEventListener('change', update);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
